import { Badge, Card, Clickable } from '@warp-ds/react';
import { t } from 'shared/locale/texts';
import { SearchVerticalConfig, type Vertical } from 'shared/search/common/config';

import { trackOpenVerticalClick } from '@/util/tracking/otherVerticalsNav';

type LinkContent = {
    vertical: string;
    path: string;
    iconName: string;
    badge?: string;
};

const OtherVerticalsLinkContent: LinkContent[] = [
    { vertical: 'last_minute', path: '/reise/restplasser/', iconName: 'Ticket', badge: 'Aktuelt nå' },
    { vertical: 'prepackage', path: '/reise/pakkereiser/resultat/', iconName: 'Charter' },
    { vertical: 'currency', path: '/reise/valuta/', iconName: 'Calculator' },
];

type OtherVerticalsNavProps = {
    activeVertical: Vertical;
    className?: string;
};

export const OtherVerticalsNav = ({ activeVertical, className }: OtherVerticalsNavProps) => {
    if (activeVertical === SearchVerticalConfig.fhh.vertical) {
        return null;
    }

    return (
        <nav className={`mx-16 md:mx-0 ${className ?? ''}`}>
            <h2 className="sr-only">{t('verticals.title')}</h2>
            <ul className="flex flex-col md:flex-row gap-16">
                {OtherVerticalsLinkContent.map(({ vertical, path, iconName, badge }) => (
                    <li className="flex flex-1" key={vertical}>
                        <Card className="w-full">
                            <div className="relative p-32">
                                {badge && (
                                    <Badge variant="positive" position="top-right" className="gap-4">
                                        <w-icon name="Sun" size="small" aria-hidden />
                                        <span>{badge}</span>
                                    </Badge>
                                )}
                                <h3 className="flex items-center gap-8 text-22 m-0">
                                    <Clickable
                                        href={path}
                                        onClick={() => trackOpenVerticalClick(vertical, path)}
                                        className="text-current hover:no-underline focus:no-underline">
                                        {t(`verticals.${vertical}`)}
                                    </Clickable>
                                    <w-icon name={iconName} size="medium" aria-hidden />
                                </h3>
                                <p className="s-text-subtle text-14 mt-16 mb-0">{t(`verticals.${vertical}_sub`)}</p>
                            </div>
                        </Card>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
